module.exports = __webpack_public_path__ + "static/media/biscuit.7ff928f4.svg";